const createHttpError = require('http-errors')
const titleize = require('titleize')
const { v4: uuidv4 } = require('uuid')
const pick = require('lodash.pick')
const omit = require('lodash.omit')

const standardErrors = [
  ['bad-request', 400],
  ['unauthorized', 401],
  ['forbidden', 403],
  ['not-found', 404],
  ['method-not-allowed', 405],
  ['conflict', 409],
  ['gone', 410],
  ['unsupported-media-type', 415],
  ['too-many-requests', 429],
  ['internal-server-error', 500],
  ['not-implemented', 501],
  ['unknown', 500],
  ['service-unavailable', 503],
]

module.exports = function(customErrors = []) {
  const errors = [...standardErrors, ...customErrors]
  const errorTemplates = new Map(
    errors.map(([code, statusCode, description]) => {
      return [
        code,
        {
          statusCode,
          properties: {
            code,
            title: titleize(code.replace(/-/g, ' ')),
            description,
          },
        },
      ]
    })
  )

  function createError(code, additionalProperties = {}) {
    if (!errorTemplates.has(code)) {
      throw new Error(`Unknown error code: ${code}`)
    }

    const errorTemplate = errorTemplates.get(code)

    const standardKeys = ['id', 'code', 'title', 'detail', 'source', 'stack', 'extra']

    const err = Object.assign(
      createHttpError(errorTemplate.statusCode),
      errorTemplate.properties,
      { id: uuidv4() },
      pick(additionalProperties, standardKeys)
    )

    const nonStandardValues = omit(additionalProperties, standardKeys)

    if (Object.keys(nonStandardValues).length) {
      err.extra = Object.assign({}, err.extra || {}, nonStandardValues)
    }

    Object.defineProperty(err, '__dooer_error__', {
      value: true,
      configurable: false,
      enumerable: false,
    })

    return err
  }

  createError.errors = errors
  return createError
}
